<script lang="ts">
	import PrivacyPolicy from "../../organisms/settings/PrivacyPolicy.svelte";
</script>

<div class="flex">
	<div class="flex-1 mr-8">
		<PrivacyPolicy/>
	</div>
</div>